import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {DbResponse} from "../../shared/interceptors/db-response";
import {first, map, switchMap} from 'rxjs/operators';
import {BoosterService} from "../../websites/website/booster/services/booster.service";
import {LoadBoosterAdvancedSettings} from "../index";
import * as boosterAdvancedSettings from '../actions/booster-advanced-settings.action';
import {TypeUtils} from "../../shared/utils/type-utils";

@Injectable()
export class BoosterAdvancedSettingsEffect {


  loadBoosterAdvancedSettings = createEffect(() => this._actions$.pipe(
    ofType(boosterAdvancedSettings.LOAD_BOOSTER_ADVANCED_SETTINGS),
    switchMap((action: LoadBoosterAdvancedSettings) => {
      return this._boosterService.getAdvancedSettings(action.payload)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              const advancedSettings = this._advancedSettingsOptions(response.data.settings);
              return new boosterAdvancedSettings.LoadBoosterAdvancedSettingsSuccess({
                websiteId: action.payload,
                entities: advancedSettings[0]
              });
            }
            return new boosterAdvancedSettings.LoadBoosterAdvancedSettingsFail({websiteId: action.payload});
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _boosterService: BoosterService,
  ) {
  }

  private _advancedSettingsOptions(settings): any {
    let excludeCss = [];
    let excludeFiles = [];
    let excludeAggregationFiles = [];
    let defaultExcludeCss = [];
    let defaultExcludeFiles = [];
    let defaultExcludeAggregationFiles = [];
    const advancedSettings = Object.keys(settings).reduce((result: any[], item: string) => {
      let options;
      if (settings[item].values) {
        options = Object.keys(settings[item].values).reduce((_result: any[], _item: string) => {
          const _newItem = {
            value: _item,
            label: settings[item].values[_item].Name ? settings[item].values[_item].Name : (settings[item].values[_item].title ? settings[item].values[_item].title : settings[item].values[_item])
          };
          _result.push(_newItem);
          return _result;
        }, []);
      }
      const field_default = item === "two_critical_status"
        ? (["not_load", "off"].includes(settings[item].value) ? "off" : "on")
        : settings[item].default;
      if (item === "two_exclude_css") {
        excludeCss = settings[item] && settings[item].value ? (settings[item].value).split(",") : [];
        defaultExcludeCss = settings[item] && settings[item].default ? (settings[item].default).split(",") : [];
      }
      if (item === "two_exclude_delay_js") {
        excludeFiles = settings[item] && settings[item].value ? (settings[item].value).split(",") : [];
        defaultExcludeFiles = settings[item] && settings[item].default ? (settings[item].default).split(",") : [];
      }
      if (item === "two_exclude_js") {
        excludeAggregationFiles = settings[item] && settings[item].value ? (settings[item].value).split(",") : [];
        defaultExcludeAggregationFiles = settings[item] && settings[item].default ? (settings[item].default).split(",") : [];
      }
      if (["select", "checkbox"].includes(settings[item].type) && TypeUtils.isUndefined(settings[item].value)) {
        settings[item].value = settings[item].default;
      }
      const newItem = {
        name: item,
        tab: settings[item].tab,
        value: settings[item].value,
        title: settings[item].title,
        description: settings[item].description,
        sub_description: settings[item].subdescription ? settings[item].subdescription : null,
        field_type: settings[item].type,
        input_type: 'string',
        options: options || null,
        default: field_default,
      };
      result.push(newItem);
      return result;
    }, []);
    return [{
      settings: advancedSettings,
      excludeCss: excludeCss,
      excludeFiles: excludeFiles,
      excludeAggregationFiles: excludeAggregationFiles,
      defaultExcludeCss: defaultExcludeCss,
      defaultExcludeFiles: defaultExcludeFiles,
      defaultExcludeAggregationFiles: defaultExcludeAggregationFiles
    }];
  }

}
